// ============================================================================
// Floating panel — newsletter open/close + WhatsApp GA tracking
// ----------------------------------------------------------------------------
// The newsletter panel is collapsed by default (height: 0). Opening it sets
// height to its content height so CSS transitions can animate the unfold.
// The original markup auto-opened on page load via `.click()` — we keep that.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  setupNewsletter();
  setupWhatsAppTracking();
});

function setupNewsletter() {
  const newsletter = document.querySelector(".floating__newsletter");
  const newsletterWrap = document.querySelector(".floating__newsletter-wrap");
  const newsletterButton = document.querySelector(
    ".floating__action-item--newsletter",
  );
  const closeButton = document.querySelector(".floating__newsletter-close");

  if (!newsletter || !newsletterButton) return;

  function open() {
    newsletterButton.classList.add("active");
    newsletter.classList.add("active");
    if (newsletterWrap) {
      newsletter.style.height = newsletterWrap.offsetHeight + "px";
    }
  }

  function close() {
    newsletterButton.classList.remove("active");
    newsletter.classList.remove("active");
    newsletter.style.height = "0px";
  }

  newsletterButton.addEventListener("click", open);

  if (closeButton) {
    closeButton.addEventListener("click", close);
  }

  // Auto-open on page load — matches the original behaviour.
  open();
}

function setupWhatsAppTracking() {
  // The WhatsApp link is the floating action item that's NOT the newsletter
  // button. Original selector targeted by ID; here we find it by class + href.
  const links = document.querySelectorAll(
    ".floating__action-item[href*='wa.me']",
  );

  links.forEach(function (link) {
    link.addEventListener("click", function () {
      if (typeof window.dataLayer !== "undefined") {
        window.dataLayer.push({ event: "click__whatsapp_post" });
      }
    });
  });
}
